export const ICON_MAP = {
  'icon-knowledgebase': '/src/svg/sidebar/knowledge-base.svg',
  'icon-workflow': '/src/svg/sidebar/flow.svg',
  'icon-variable': '/src/svg/sidebar/var.svg',
  'icon-branding': '/src/svg/sidebar/brand.svg',
  'icon-category': '/src/svg/sidebar/categ.svg',
  'icon-theme': '/src/svg/sidebar/theme.svg',
  'icon-voice': '/src/svg/sidebar/mic.svg',
  'icon-agent': '/src/svg/sidebar/agent.svg',
  'icon-keyword': '/src/svg/sidebar/sensi.svg',
  'icon-terms': '/src/svg/sidebar/tc.svg',
  'icon-analytics': '/src/svg/sidebar/analytics.svg',
  'icon-conversation': '/src/svg/sidebar/conversation2.svg',
  'icon-chat-console': '/src/svg/sidebar/bots.svg',
  'icon-link-agent': '/src/svg/sidebar/link-to-agent.svg',
  'icon-form': '/src/svg/sidebar/form.svg',
  'icon-home': '/src/svg/sidebar/home.svg',
  'icon-users': '/src/svg/sidebar/users.svg',
  'icon-config': '/src/svg/sidebar/config.svg',
  'icon-insight': '/src/svg/sidebar/insight.svg',
  'icon-integration': '/src/svg/sidebar/integration.svg',
  'icon-systems': '/src/svg/sidebar/systems.svg',
  'icon-channels': '/src/svg/sidebar/channels.svg',
  'icon-deploy': '/src/svg/sidebar/deploy.svg',
  'icon-script': '/src/svg/sidebar/script.svg',
  'icon-restrictions': '/src/svg/sidebar/restrictions.svg',
  'icon-integrations': '/src/svg/sidebar/integration.svg',
  'icon-prompt-settings': '/src/svg/sidebar/prompt-settings.svg',
};

const BOT_SETTINGS = [
  {
    routeId: 1,
    routeOrder: 1,
    routeTo: '/dashboard',
    routeTitle: 'Home',
    routeIcon: 'icon-home',
    isMainLink: true,
  },
  {
    routeId: 2,
    routeOrder: 2,
    routeTo: '/users',
    routeTitle: 'User',
    routeIcon: 'icon-users',
    isMainLink: true,
  },
  {
    routeId: 3,
    routeOrder: 3,
    routeTitle: 'Knowledge Base',
    routeTo: '/knowledge-base',
    routeIcon: 'icon-knowledgebase',
  },
  {
    routeId: 4,
    routeOrder: 4,
    routeTitle: 'Bot Configuration',
    routeIcon: 'icon-config',
    routeTo: '/bot/configuration',
    collapsible: true,
    children: [
      {
        routeId: 5,
        routeOrder: 1,
        routeTitle: 'Workflows',
        routeTo: '/bot/Workflow/:id',
        routeIcon: 'icon-workflow',
        isSetting: true,
      },
      {
        routeId: 6,
        routeOrder: 2,
        routeTitle: 'Variables',
        routeTo: '/variable-management',
        routeIcon: 'icon-variable',
        isSetting: true,
      },
      {
        routeId: 7,
        routeOrder: 3,
        routeTitle: 'Branding',
        routeTo: '/bot/branding/:id',
        routeIcon: 'icon-branding',
        isSetting: true,
      },
      {
        routeId: 8,
        routeOrder: 4,
        routeTitle: 'Categories',
        routeTo: '/bot/categories/:id',
        routeIcon: 'icon-category',
        isSetting: true,
      },
      {
        routeId: 9,
        routeOrder: 5,
        routeTitle: 'Themes',
        routeTo: '/bot/theme/:id',
        routeIcon: 'icon-theme',
        isSetting: true,
      },
      {
        routeId: 10,
        routeOrder: 6,
        routeTitle: 'Voice',
        routeTo: '/bot/voice-recording/:id',
        routeIcon: 'icon-voice',
        isSetting: true,
      },
      {
        routeId: 13,
        routeOrder: 7,
        routeTitle: 'Prompt Settings',
        routeTo: '/bot/prompt-settings/:id',
        routeIcon: 'icon-prompt-settings',
        isSetting: true,
      },
      {
        routeId: 11,
        routeOrder: 8,
        routeTitle: 'Sensitive Keywords',
        routeTo: '/bot/sensitive-keyword/:id',
        routeIcon: 'icon-keyword',
        isSetting: true,
      },
      {
        routeId: 12,
        routeOrder: 9,
        routeTitle: 'Terms & Conditions',
        routeTo: '/bot/terms-conditions/:id',
        routeIcon: 'icon-terms',
        isSetting: true,
      },
    ],
  },
  {
    routeId: 13,
    routeOrder: 5,

    routeTitle: 'Insights',
    routeIcon: 'icon-insight',
    routeTo: '/insights',
    collapsible: true,
    children: [
      {
        routeId: 14,
        routeOrder: 1,
        routeTitle: 'Dashboard',
        routeTo: '/bot/analytics/:id',
        routeIcon: 'icon-analytics',
        isSetting: true,
      },
      {
        routeId: 15,
        routeOrder: 2,
        routeTitle: 'Forms',
        routeTo: '/bot/form-responses/:id',
        routeIcon: 'icon-form',
        isSetting: true,
      },
      {
        routeId: 16,
        routeOrder: 3,
        routeTitle: 'Conversations',
        routeTo: '/bot/conversation/:id',
        routeIcon: 'icon-conversation',
        isSetting: true,
      },
    ],
  },

  {
    routeId: 17,
    routeOrder: 6,

    routeTitle: 'Integrations',
    routeIcon: 'icon-integrations',
    routeTo: '/integrations',
    collapsible: true,
    children: [
      {
        routeId: 18,
        routeOrder: 1,
        routeTitle: 'Systems',
        routeIcon: 'icon-systems',
        routeTo: '/bot/link-to-agent/:id',
      },
      {
        routeId: 19,
        routeOrder: 2,
        routeTitle: 'Channels',
        routeIcon: 'icon-channels',
        routeTo: '/console/link-to-agent',
      },
    ],
  },
  {
    routeId: 20,
    routeOrder: 7,

    routeTitle: 'Deploy',
    routeIcon: '/src/svg/sidebar/deploy.svg',
    routeTo: '/deploy',
    collapsible: true,
    children: [
      {
        routeId: 21,
        routeOrder: 1,
        routeTitle: 'Script',
        routeIcon: 'icon-script',
        routeTo: '/bot/script/:id',
      },
      {
        routeId: 22,
        routeOrder: 2,
        routeTitle: 'Restrictions',
        routeIcon: 'icon-restrictions',
        routeTo: '/console/settings/:id',
      },
    ],
  },
  {
    routeId: 23,
    routeOrder: 8,
    routeTitle: 'Chat Interface',
    routeTo: '/chat-console',
    routeIcon: 'icon-chat-console',
  },
];

export { BOT_SETTINGS };
